enum ActionTypes {
  MAIN_SET_PAGE = 'ADMIN_MENTOR_MAIN_SET_PAGE',
  MAIN_SET_SEARCH = 'ADMIN_MENTOR_MAIN_SET_SEARCH',
  MAIN_SET_TAGS = 'ADMIN_MENTOR_MAIN_SET_TAGS',
  MAIN_SET_CUSTOM_TAGS = 'ADMIN_MENTOR_MAIN_SET_CUSTOM_TAGS',
  MAIN_SET_ACTIVE_COLUMNS = 'ADMIN_MENTOR_MAIN_SET_ACTIVE_COLUMNS ',
  MAIN_SET_EXPORT_COLUMNS = 'ADMIN_MENTOR_MAIN_SET_EXPORT_COLUMNS ',
  MAIN_SET_TAKE = 'ADMIN_MENTOR_MAIN_SET_TAKE',
  MAIN_SET_ORDER = 'ADMIN_MENTOR_MAIN_SET_ORDER',

  ASSOCIATE_SET_PAGE = 'ADMIN_MENTOR_ASSOCIATE_SET_PAGE',
  ASSOCIATE_SET_SEARCH = 'ADMIN_MENTOR_ASSOCIATE_SET_SEARCH',
  ASSOCIATE_SET_TAGS = 'ADMIN_MENTOR_ASSOCIATE_SET_TAGS',
  ASSOCIATE_SET_ACTIVE_COLUMNS = 'ADMIN_MENTOR_ASSOCIATE_SET_ACTIVE_COLUMNS ',
  ASSOCIATE_SET_TAKE = 'ADMIN_MENTOR_ASSOCIATE_SET_TAKE',
  ASSOCIATE_SET_ORDER = 'ADMIN_MENTOR_ASSOCIATE_SET_ORDER',

  HISTORY_SET_PAGE = 'ADMIN_MENTOR_HISTORY_SET_PAGE',
  HISTORY_SET_SEARCH = 'ADMIN_MENTOR_HISTORY_SET_SEARCH',
  HISTORY_SET_TAGS = 'ADMIN_MENTOR_HISTORY_SET_TAGS',
  HISTORY_SET_ACTIVE_COLUMNS = 'ADMIN_MENTOR_HISTORY_SET_ACTIVE_COLUMNS ',
  HISTORY_SET_TAKE = 'ADMIN_MENTOR_HISTORY_SET_TAKE',
  HISTORY_SET_ORDER = 'ADMIN_MENTOR_HISTORY_SET_ORDER',

  ONGOING_SET_PAGE = 'ADMIN_MENTOR_ONGOING_SET_PAGE',
  ONGOING_SET_SEARCH = 'ADMIN_MENTOR_ONGOING_SET_SEARCH',
  ONGOING_SET_TAGS = 'ADMIN_MENTOR_ONGOING_SET_TAGS',
  ONGOING_SET_ACTIVE_COLUMNS = 'ADMIN_MENTOR_ONGOING_SET_ACTIVE_COLUMNS ',

  INTERVIEW_SET_PAGE = 'ADMIN_MENTOR_INTERVIEW_SET_PAGE',
  INTERVIEW_SET_ORDER = 'ADMIN_MENTOR_INTERVIEW_SET_ORDER',
}

export default ActionTypes;
